(function () {
  var MAX = 4;
  function money(c) {
    try { return Shopify.formatMoney(c, window.theme && theme.moneyFormat || '${{amount}}'); } catch (e) { return '$' + (c / 100).toFixed(2); }
  }
  function esc(s) {
    return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; });
  }
  function card(p) {
    var v = p.variants && p.variants[0];
    var multi = p.variants && p.variants.length > 1;
    var img = p.featured_image ? '<img src="' + p.featured_image + '" alt="" loading="lazy" width="56" height="56">' : '';
    var tail = '';
    if (multi) {
      var opts = p.variants.filter(function (x) { return x.available !== false; }).map(function (x) {
        return '<option value="' + x.id + '">' + esc(x.title) + '</option>';
      }).join('');
      tail = '<div class="cedar-upsell__pick"><select class="cedar-upsell__select" data-cedar-enhance data-cedar-pick data-dd-class="cedar-dd--sm" data-placeholder="Choose program" aria-label="Choose program"><option value="">Choose program</option>' + opts + '</select></div>';
    } else if (v) {
      tail = '<button type="button" class="cedar-upsell__add" data-cedar-add="' + v.id + '">Add</button>';
    } else {
      tail = '<a class="cedar-upsell__add" href="' + p.url + '">View</a>';
    }
    return '<li class="cedar-upsell__item' + (multi ? ' cedar-upsell__item--pick' : '') + '">' + img + '<div class="cedar-upsell__info"><a href="' + p.url + '">' + esc(p.title) + '</a><span>' + money(p.price) + '</span></div>' + tail + '</li>';
  }
  function load(pid, intent) {
    return fetch('/recommendations/products.json?product_id=' + pid + '&limit=10&intent=' + intent)
      .then(function (r) { return r.json(); })
      .then(function (d) { return d.products || []; })
      .catch(function () { return []; });
  }
  function fill() {
    var box = document.querySelector('[data-cedar-upsell]');
    if (!box || box.dataset.filled) return;
    box.dataset.filled = '1';
    var list = box.querySelector('ul');
    if (list.children.length) return;
    var inCart = box.dataset.inCart || '';
    function pick(products) {
      return products.filter(function (p) { return p.available !== false && inCart.indexOf(',' + p.id + ',') === -1; }).slice(0, MAX);
    }
    load(box.dataset.productId, 'complementary').then(function (a) {
      var out = pick(a);
      if (out.length) return out;
      return load(box.dataset.productId, 'related').then(pick);
    }).then(function (out) {
      list.innerHTML = out.map(card).join('');
    });
  }
  function refresh() {
    var drawer = document.querySelector('cart-drawer');
    return fetch('/?sections=cart-drawer,cart-icon-bubble').then(function (r) { return r.json(); }).then(function (s) {
      var doc = new DOMParser().parseFromString(s['cart-drawer'], 'text/html');
      var inner = doc.querySelector('.drawer__inner');
      var cur = document.querySelector('#CartDrawer .drawer__inner');
      if (inner && cur) cur.innerHTML = inner.innerHTML;
      if (drawer) drawer.classList.toggle('is-empty', !!doc.querySelector('.drawer__inner-empty'));
      var bub = new DOMParser().parseFromString(s['cart-icon-bubble'], 'text/html').querySelector('.shopify-section');
      var tgt = document.getElementById('cart-icon-bubble');
      if (bub && tgt) tgt.innerHTML = bub.innerHTML;
      fill();
    });
  }
  function openDrawer(trigger) {
    var d = document.querySelector('cart-drawer');
    if (!d || (trigger && trigger.closest && trigger.closest('cart-drawer'))) return;
    d.classList.remove('is-empty');
    if (typeof d.open === 'function') d.open();
  }
  function add(id, trigger) {
    return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: Number(id), quantity: 1 }) })
      .then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); })
      .then(function () { return refresh(); })
      .then(function () { openDrawer(trigger); });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-cedar-add]');
    if (!b) return;
    e.preventDefault();
    b.disabled = true;
    add(b.dataset.cedarAdd, b).catch(function () {}).then(function () { b.disabled = false; });
  });
  document.addEventListener('change', function (e) {
    var s = e.target;
    if (!s.matches || !s.matches('[data-cedar-pick]') || !s.value) return;
    var wrap = s.closest('.cedar-dd');
    if (wrap) wrap.classList.add('is-busy');
    add(s.value, s).catch(function () {}).then(function () {
      s.value = '';
      if (s.__sync) s.__sync();
      if (wrap) wrap.classList.remove('is-busy');
    });
  });
  new MutationObserver(function () { fill(); }).observe(document.documentElement, { childList: true, subtree: true });
  document.addEventListener('DOMContentLoaded', fill);
})();
